import { render, staticRenderFns } from "./BaseCollectionPrintSheet.vue?vue&type=template&id=fec1fa3a"
import script from "./BaseCollectionPrintSheet.vue?vue&type=script&lang=js"
export * from "./BaseCollectionPrintSheet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports